import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Inventory from '../views/Inventory.vue'
import ItemDetails from '../components/inventory/ItemDetails.vue';
import Orders from '../views/Orders.vue'
import Customers from '../views/Customers.vue'
import OrderDetails from '../components/orders/OrderDetails.vue'
import OrderForm from '../components/orders/OrderForm.vue'
import Shipping from "../views/Shipping.vue";
import Timecard from "../views/Timecard.vue";
import Employees from "../views/Employees.vue";
import { authGuard } from "../auth/authGuard";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    meta: { title: 'Dashboard' },
    component: Dashboard,
      beforeEnter: authGuard
  },
  {
    path: "/inventory",
    name: "inventory",
    meta: { title: 'Inventory' },
    component: Inventory,
    beforeEnter: authGuard,
    props: true,
    children: [{
      path: "details",
      name: 'itemDetails',
      meta: { title: 'Item Details' },
      component: ItemDetails,
      beforeEnter: authGuard },
    ]
  },
  {
    path: "/orders",
    name: "orders",
    meta: { title: 'Orders' },
    component: Orders,
    beforeEnter: authGuard,
    props: true,
    children: [{
      path: "details",
      name: 'orderDetails',
      component: OrderDetails,
      beforeEnter: authGuard },
      {path: "orderId",
      name: 'orderId',
      component: OrderForm,
      beforeEnter: authGuard,}
    ]
  },
  {
    path: "/customers",
    name: "customers",
    meta: { title: 'Customers' },
    component: Customers,
    beforeEnter: authGuard,
    props: true,
    // children: [{
    //   path: "details",
    //   name: 'orderDetails',
    //   component: OrderDetails,
    //   beforeEnter: authGuard },
    // ]
  },
  {
    path: "/shipping",
    name: "shipping",
    meta: { title: 'Shipping' },
    component: Shipping,
    beforeEnter: authGuard
  },
  {
    path: "/timecard",
    name: "timecard",
    meta: { title: 'Time Card' },
    component: Timecard,
    beforeEnter: authGuard
  },
  {
    path: "/employees",
    name: "employees",
    meta: { title: 'Employees' },
    component: Employees,
    beforeEnter: authGuard
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
      .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router
